export default {
  BASE_URL: '/pc/crm/mem/cost',
  api: [
    {
      name: 'getPaySelectOptions',
      desc: '缴费年限的下拉框选择',
      method: 'GET',
      path: 'getPaySelectOptions/{memCode}'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/member/common.js